import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ChevronLeft, ChevronRight, Heart, ShoppingCart, Shuffle, Maximize, Eye, Phone, MapPin, Mail, User, Search } from 'lucide-react';
import './Home.css';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer'
import SearchHeader from '../../Components/Header/SearchHeader';
import { getproductsfordashboard, getTagList, addToCart, addToWishlist, getWishist, getcartwishlistcount, getProducts, getdashboardcategory } from '../../redux/services/productService';
import BottomNavigation from '../../Components/BottomMenu/BottomNavigation';
import { showError } from '../../utils/alert';
import HeaderDummy from '../../Components/Header/HeaderDummy';
import { BuildVersion } from '../../config';

const Home = () => {
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.auth);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [wishlist, setWishlist] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [slides, setSlides] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const cardsPerSlide = 3; // Number of cards visible at a time
  const [categorySlideIndex, setcategorySlideIndex] = useState(0)
  const categoryCardsPerSlide = 6;
  const [latestProducts, setlatestProducts] = useState([])
  const [latestCurrentIndex, setLatestCurrentIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [userId, setUserId] = useState(null);
  const [cartChange, setCartChange] = useState(false);
  const [cartTrigger, setCartTrigger] = useState(0);
  const [wishlistTrigger, setWishlistTrigger] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isLowEndDevices, setIsLowEndDevices] = useState(window.innerWidth <= 950);
   const [cartwishlistCount, setCartwishlistCount] = useState({CartCount:0,WishlistCount:0,CartAmount:0});

     const navigate = useNavigate();
  useEffect(() => {
  const handleResize = () => setIsLowEndDevices(window.innerWidth <= 950);
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const storedData = localStorage.getItem('userData');

    if (storedData) {
      let parsedData = JSON.parse(storedData);

      // Check if parsedData is still a string (double stringified case)
      if (typeof parsedData === 'string') {
        parsedData = JSON.parse(parsedData);
      }

      if (parsedData && parsedData[0]?.UserId) {
        setUserId(parsedData[0].UserId);
      }
    }
  }, []);





  // Fetch products from API
  useEffect(() => {
    const fetchBannerProducts = async () => {
      try {
        const res = await getproductsfordashboard({
          BE:1,
          Type: 1,
        });
       
        if (res.status == "Success") {
          const parsedResult = JSON.parse(res.result);
        
          const gradients = [
            "linear-gradient(135deg, #fcbf08 0%, #e31b22 100%)",
            "linear-gradient(135deg, #fcbf08 0%, #e31b22 100%)",
            "linear-gradient(135deg, #fcbf08 0%, #e31b22 100%)",

          ];
          setSlides(parsedResult?.Banner?.slice(0, 3).map((product, index) => ({
            id: product.Id,
            title: product.Name,
            price: `AED ${product?.Rate?.toFixed(2)}`,
            image:getImageUrl(product?.Image??""),
            description: product.Name,
            gradient: gradients[index] || gradients[0],
            product: product,
            Show_cart:product?.Show_cart
          })));
          setlatestProducts(parsedResult?.LatestProduct??[])
        }
        else {
          setSlides([])
          setlatestProducts([])
        }

      } catch (error) {
        console.error("Error fetching products:", error);
        setSlides([])
        setlatestProducts([])
      }
    };

    fetchBannerProducts();
  }, []);
    useEffect(() => {
    const fetchdashboardcategory = async () => {
      try {
        const res = await getdashboardcategory({
          BE:1,
        });
       
       
        if (res.status == "Success") {
          const parsedResult = JSON.parse(res.result);
         
          setCategories(parsedResult?.Category ?? [])
          setSubCategories(parsedResult?.FeaturedCategory ?? [])
        }
        else {
          setCategories([])
          setSubCategories([])
        }

      } catch (error) {
        console.error("Error fetching products:", error);
        setCategories([])
        setSubCategories([])

      }
    };

    fetchdashboardcategory();
  }, []);
  useEffect(() => {
    const fetchProducts = async () => {
      try {
   
         const res = await getProducts({
          category: selectedSubCategory?.Id,
          // subCategory: selectedSubCategory?.Id,
          //itemBrand: selectedBrand?.Id,
          pageSize: 20,
        });
        if (res.status == "Success") {
          const parsedResult = JSON.parse(res.result);
        
          
          setFeaturedProducts(parsedResult.Data || []);
          const gradients = [
            "linear-gradient(135deg, #fcbf08 0%, #e31b22 100%)",
            "linear-gradient(135deg, #fcbf08 0%, #e31b22 100%)",
            "linear-gradient(135deg, #fcbf08 0%, #e31b22 100%)",

          ];
      
        }
        else {
          setFeaturedProducts([])
        }

      } catch (error) {
        console.error("Error fetching products:", error);
        setFeaturedProducts([])
      }
    };

    fetchProducts();
  }, [selectedCategory, selectedSubCategory, selectedBrand]);
  
  useEffect(() => {
    const fetchCartWishlistCount = async () => {
      try {
        const res = await getcartwishlistcount({BE:1});
        if(res?.status =="Success"){
          const parsedResult = JSON.parse(res.result);
          
          setCartwishlistCount(parsedResult[0]);
        }
        else{
          setCartwishlistCount({});
        }
        
      } catch (error) {
        console.error("Error fetching wishlist:", error);
        setCartwishlistCount({});
      }
    };

    fetchCartWishlistCount();
  }, [wishlistTrigger,cartTrigger]);
  

  // useEffect(() => {
  //   const fetchCategories = async () => {
  //     try {
  //       const res = await getTagList(3004); // or pass tagId if required
  //       // API returns stringified JSON inside result
  //       if (res?.status === "Success" && res?.result) {
  //         const parsedResult = JSON.parse(res?.result);
  //         setCategories(parsedResult || []);
  //       }
  //       else {
  //         setCategories([])
  //       }

  //     } catch (error) {
  //       console.error("Error fetching categories:", error);
  //       setCategories([])
  //     }
  //   };
  //   fetchCategories();
  // }, []);
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const res = await getTagList(3008);

        if (res?.status === "Success" && res?.result) {
          let parsedResult = [];

          try {
            parsedResult = JSON.parse(res.result);
          } catch {
            console.warn("Invalid JSON in getTagList result");
          }

          const firstTen = Array.isArray(parsedResult)
            ? parsedResult.slice(0, 10)
            : [];

          setBrands(firstTen);
        } else {
          setBrands([]);
        }
      } catch (error) {
        console.error("Error fetching brands:", error);
        setBrands([]);
      }
    };

    fetchBrands();
  }, []);






 

  // Auto slide functionality
  useEffect(() => {
    if (slides.length === 0) return;
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 10000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const totalSlides = Math.ceil(featuredProducts.length / cardsPerSlide);

const nextSlide = () => {
    if (window.innerWidth <= 768) {
      // On mobile, scroll to next card smoothly
      const container = document.querySelector('.products-carousel-track');
      if (container) {
        const cardWidth = 290; // Approximate card width + margin
        container.scrollBy({
          left: cardWidth,
          behavior: 'smooth'
        });
      }
    } else {
      const container = document.querySelector('.products-carousel-container');
  if (container) container.scrollBy({ left: 300, behavior: 'smooth' });

    }
  };

  const prevSlide = () => {
    if (window.innerWidth <= 768) {
      // On mobile, scroll to previous card smoothly
      const container = document.querySelector('.products-carousel-track');
      if (container) {
        const cardWidth = 290; // Approximate card width + margin
        container.scrollBy({
          left: -cardWidth,
          behavior: 'smooth'
        });
      }
    } else {
      const container = document.querySelector('.products-carousel-container');
  if (container) container.scrollBy({ left: -300, behavior: 'smooth' });

    }
  };

  const nextHeroSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevHeroSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };
  const nextLatestSlide = () => {
 
  if (window.innerWidth <= 768) {
    // Mobile: scroll behavior
    const container = document.querySelector('.products-carousel-track-latest');
   if (container) {
        const cardWidth = 290; // Approximate card width + margin
        container.scrollBy({
          left: cardWidth,
          behavior: 'smooth'
        });
      }
  } else {
  
    const container = document.querySelector('.products-carousel-container-latest');
  if (container) container.scrollBy({ left: 300, behavior: 'smooth' });

  }
};

const prevLatestSlide = () => {

  if (window.innerWidth <= 768) {
    // Mobile: scroll behavior
    const container = document.querySelector('.products-carousel-track-latest');
     if (container) {
        const cardWidth = 290; // Approximate card width + margin
        container.scrollBy({
          left: -cardWidth,
          behavior: 'smooth'
        });
      }
  } else {
    const container = document.querySelector('.products-carousel-container-latest');
  if (container) container.scrollBy({ left: -300, behavior: 'smooth' });

  }
  
};
  const nextCategorytSlide = () => {
 
  if (window.innerWidth <= 768) {
    // Mobile: scroll behavior
    const container = document.querySelector('.category-carousel-track');
   if (container) {
        const cardWidth = 290; // Approximate card width + margin
        container.scrollBy({
          left: cardWidth,
          behavior: 'smooth'
        });
      }
  } else {
  
    const container = document.querySelector('.category-carousel-container');
  if (container) container.scrollBy({ left: 150, behavior: 'smooth' });

  }
};

const prevCategorySlide = () => {

  if (window.innerWidth <= 768) {
    // Mobile: scroll behavior
    const container = document.querySelector('.category-carousel-track');
     if (container) {
        const cardWidth = 290; // Approximate card width + margin
        container.scrollBy({
          left: -cardWidth,
          behavior: 'smooth'
        });
      }
  } else {
    const container = document.querySelector('.category-carousel-container');
  if (container) container.scrollBy({ left: -150, behavior: 'smooth' });

  }
  
};
// Update the cardsPerSlide calculation to be responsive
// Add resize listener


// Recalculate total slides when products or cardsPerSlide changes
const latestTotalSlides = Math.ceil(latestProducts.length / cardsPerSlide);

// Reset index when total slides change
useEffect(() => {
  if (latestCurrentIndex >= latestTotalSlides) {
    setLatestCurrentIndex(Math.max(0, latestTotalSlides - 1));
  }
}, [latestTotalSlides, latestCurrentIndex]);

const categoryTotalSlides = Math.ceil(categories.length / categoryCardsPerSlide);

// Reset index when total slides change
useEffect(() => {
  if (categorySlideIndex >= categoryTotalSlides) {
    setcategorySlideIndex(Math.max(0, categoryTotalSlides - 1));
  }
}, [categoryTotalSlides, categorySlideIndex]);
  const handleAddToWishlist = async (product) => {
    try {
      const payload = {
        transId: 0,
        product: product.Id,
        quantity: 1,
        customer: userId,
        remarks: "",
        be: 0,
        rate: product.Rate
      };
      await addToWishlist(payload);
      setWishlist([...wishlist, { Product: product.Id }]); // update state
      setWishlistTrigger(prev => prev + 1); // Trigger wishlist count refresh
    } catch (err) {
      console.error("Error adding to wishlist:", err);
    }
  };

  const handleAddToCart = async (product) => {
    if (product.Stock == 0 || product.Stock === 0.0) {
      showError("Product is out of stock. Please try after the stock update.");
      return;
    }
    // if (product?.Rate == 0) {
    //   showError("This product cannot be added to the cart because its price is not available");
    //   return;
    // }
    try {
      const payload = {
        transId: 0,
        date: new Date().toISOString().split("T")[0],
        customer: userId,
        warehouse: 2,
        remarks: "",
        discountType: 1,
        discountCouponRef: "ref01",
        discountRef: "Ref809",
        sampleRequestedBy: 1,
        product: product.Id,
        qty: 1,
        rate: product.Rate || 0,
        unit: 1,
        totalRate: product.Rate || 0,
        addCharges: 0,
        discount: 0,
        discountAmt: 0,
        discountRemarks: "",
        be: 0,
      };
      await addToCart(payload);
      const newCart = [...cartItems, { productId: product.Id }];
      setCartItems(newCart);
      setCartChange(!cartChange);
      setCartTrigger(prev => prev + 1); // Trigger cart count refresh
    } catch (err) {
      console.error("Error adding to cart:", err);
    }
  };

  const brandColors = [
    "#ffadad", "#ffd6a5", "#fdffb6", "#caffbf", "#9bf6ff", "#a0c4ff", "#bdb2ff", "#ffc6ff"
  ];

  const handleProductView = (product) => {
    navigate('/view', { state: { product, from: 'home' } });
  };

  const getImageUrl = (url) => {
  if (!url) return '';
  // Add timestamp to bypass cache
  const separator = url.includes('?') ? '&' : '?';
   const version = BuildVersion || new Date().getTime(); // Fallback to current timestamp
  return `${url}${separator}t=${version}`;
};

  return (
    <div className="home-container">
      {isLowEndDevices ? (
  <>
  {/* ✅ Responsive style */}
      <style>
        {`
        .category-card-sm {
             
              padding: 12px !important;
              gap:12px
            }
          
          
        `}
      </style>
      <Header />
      <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={categories}
        selectedCategory={selectedCategory}
        cartTrigger={cartTrigger}
        wishlistTrigger={wishlistTrigger}
        onCategoryChange={(category) => {
          setSelectedCategory(category);
          setSelectedSubCategory(null);
        }} />
     </>) : (
  <>
        <HeaderDummy/>
    <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={categories}
        selectedCategory={selectedCategory}
        cartTrigger={cartTrigger}
        wishlistTrigger={wishlistTrigger}
        onCategoryChange={(category) => {
          setSelectedCategory(category);
          setSelectedSubCategory(null);
        }} />
    <Header />
  </>
)}   

      {/* Hero Carousel */}
      {slides.length > 0 && (
        <section className="hero-carousel">
          <div className="carousel-container">
            <div
              className="carousel-slide"
              style={{ background: slides[currentSlide]?.gradient }}
            >
              <div key={currentSlide} className="slide-content">
                <div className="slide-image">
                  <img src={slides[currentSlide]?.image} alt={slides[currentSlide]?.title} />
                </div>
                <div className="slide-text">
                  {/* <p className="slide-subtitle">New Available In Stock</p> */}
                  <h1 className="slide-title">{slides[currentSlide]?.title}</h1>
                  <p className="slide-price">{slides[currentSlide]?.price}</p>
                  {slides[currentSlide]?.Show_cart ==1 ?
                  <button className="shop-now-btn" onClick={async () => { await handleAddToCart(slides[currentSlide]?.product);}}>ADD TO CART</button>
                  :null}
                </div>

              </div>
            </div>

            <button className="carousel-btn prev-btn" onClick={prevHeroSlide}>
              <ChevronLeft size={24} />
            </button>
            <button className="carousel-btn next-btn" onClick={nextHeroSlide}>
              <ChevronRight size={24} />
            </button>

            <div className="carousel-indicators">
              {slides.map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>
        </section>
      )}
      <div className='section-comb'>
        {/* Explore Categories */}
        {categories && categories.length > 0 ?
          <section className="explore-categories">
            <h2>Explore Categories</h2>

             <div className="carousel-wrapper">
              <div className="category-carousel-container">
                <div
                  className="category-carousel-track"
                  style={{
                    transform: `translateX(-${categorySlideIndex * (100 / categoryCardsPerSlide)}%)`
                  }}
                >
                     {categories.map((category) => {
          // 👇 choose image based on ID
          return (
            <div
              key={category.Id}
              className={`category-card-sm ${selectedCategory?.Id === category.Id ? "selected" : ""}`}
              onClick={
                () => {
                // setSelectedCategory(category);
                // setSelectedSubCategory(null);
                // setSelectedBrand(null);
                navigate("/shop", {
                  state: {
                    category: category,
                  },
                })
              }
            }
              style={{
                flex: "0 0 150px",
                backgroundColor: "#fff4f0",
                borderRadius: "16px",
                textAlign: "center",
                padding: "10px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                border:
                  selectedCategory?.Id === category.Id
                    ? "2px solid #ff8c66"
                    : "2px solid transparent",
                maxWidth: "200px",
                minWidth:"200px",
                maxHeight:"160px",
                minHeight:"160px"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 2px 8px rgba(0, 0, 0, 0.05)";
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexDirection:"column",
                  marginBottom: "2px",
                  maxHeight:"200px",
                }}
              >
                <img
                  src={category?.Image}
                  alt={""}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100px",
                    
                    borderRadius: "10px",
                    minHeight:"100px"
                  }}
                />
              </div>

                           <h3
                             style={{
                               fontSize: "13px",
                               fontWeight: 500,
                               color: "#222",
                               margin: "2px 0 2px 0px",
                               width: "160px",       // set the width you want
                               overflow: "hidden",
                               whiteSpace: "nowrap",
                               textOverflow: "ellipsis",
                               margin: "auto"

                             }}
                           >
                             {category?.Name}
                           </h3>

                           <p style={{
                             fontSize: "13px", color: "#777", margin: "2px 0 2px 0px",
                             width: "160px",       // set the width you want
                             overflow: "hidden",
                             whiteSpace: "nowrap",
                             textOverflow: "ellipsis", margin: "auto"
                           }}>
                             {category?.ProductCount} products
                           </p>
                         </div>
                       );
                     })}
                  </div>
                  </div>
                   {/* Navigation Buttons */}
              <button className="nav-btn left" style={{ transform: "translateY(0px) translateX(-10px)" }} onClick={prevCategorySlide}>‹</button>
              <button className="nav-btn right" style={{ transform: "translateY(0px) translateX(10px)" }} onClick={nextCategorytSlide}>›</button>

              {/* Dots */}
              <div className="dots">
                {Array.from({ length: categoryTotalSlides }).map((_, index) => (
                  <span
                    key={index}
                    className={`dot ${index === categorySlideIndex ? "active" : ""}`}
                    onClick={() => {
                     setcategorySlideIndex(index)}}
                  />
                ))}
              </div>
                  </div>
          
          </section>
          : ""}
        {/* Subcategories instead of hardcoded tabs */}
        {/* {selectedCategory && (
        <section className="subcategories">
          <div className="section-header">
            <h2>{selectedCategory.Name} - Subcategories</h2>
            <div className="product-tabs">
              {subCategories.map((sub) => (
                <button
                  key={sub.Id}
                  className={`tab-btn ${selectedSubCategory?.Id === sub.Id ? 'active' : ''}`}
                  onClick={() => setSelectedSubCategory(sub)}
                >
                  {sub.Name}
                </button>
              ))}

            </div>
          </div>
        </section>
      )} */}

        {/* Featured Products */}
        {subCategories && subCategories.length > 0 ?
          <section className="featured-products">
            <div className="section-header">
              <h2 >FEATURED PRODUCTS</h2>
             <div className="product-tabs">
  {subCategories.length > 0 && (
    <>
      {/* All Products button */}
      <button
        className={`tab-btn ${!selectedSubCategory ? 'active' : ''}`}
        onClick={() => setSelectedSubCategory(null)} // or 0 if API expects numeric
      >
        ALL PRODUCTS
      </button>

      {/* Render all subcategories */}
      {subCategories.map((sub) => (
        <button
          key={sub.Id}
          className={`tab-btn ${selectedSubCategory?.Id === sub.Id ? 'active' : ''}`}
          onClick={() => setSelectedSubCategory(sub)}
        >
          {sub.Name}
        </button>
      ))}
    </>
  )}
</div>

            </div>


            <div className="carousel-wrapper">
              <div className="products-carousel-container">
                <div
                  className="products-carousel-track"
                  style={{
                    transform: `translateX(-${currentIndex * (100 / cardsPerSlide)}%)`
                  }}
                >
                  {featuredProducts.map((product) => (
                    <div key={product.Id} className="product-card-home" >
                      {(product.Stock === 0 || product.Stock === 0.0) && (
                        <div className="home-product-card-sold-out-badge">Sold Out</div>
                      )}
                      <div className="product-image-home" >
                        <img src={product.Image} alt={product.Name} onClick={() => handleProductView(product)} loading="lazy"/>
                        <div className="product-overlay">
                          <button className="overlay-btn" onClick={() => handleAddToCart(product)}><ShoppingCart size={20} style={{
                            transform: "scaleX(-1)",   // FLIP horizontally
                            transformOrigin: "center"
                          }} /></button>
                          {/* <button className="overlay-btn"><Search size={20} /></button> */}
                          {/* <button className="overlay-btn"><Shuffle size={20} /></button> */}
                          <button className="overlay-btn" onClick={() => handleAddToWishlist(product)}><Heart size={20} /></button>
                        </div>

                      </div>
                      <div className="product-info-home" onClick={() => handleProductView(product)}>
                        <h3>{product.Name}</h3>
                        <div className="product-pricing">
                          {/* <span className="old-price">AED {(product?.Rate + 20).toFixed(2)}</span> */}
                          <span className="current-price" >{(product?.Rate ?? 0).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} AED</span>

                          {/* <button
                            className="enlarge-btn"
                            // style={{marginRight:"30px"}}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent opening popup when clicking enlarge
                              setSelectedProduct(product);
                              setShowPopup(true);
                            }}
                          >
                            <Maximize size={18} />Click to Enlarge
                          </button> */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Navigation Buttons */}
              <button className="nav-btn left" style={{ transform: "translateY(20px)" }} onClick={prevSlide}>‹</button>
              <button className="nav-btn right" style={{ transform: "translateY(20px)" }} onClick={nextSlide}>›</button>

              {/* Dots */}
              <div className="dots">
                {Array.from({ length: totalSlides }).map((_, index) => (
                  <span
                    key={index}
                    className={`dot ${index === currentIndex ? "active" : ""}`}
                    onClick={() => setCurrentIndex(index)}
                  />
                ))}
              </div>
            </div>
          </section>
          : ""}

           {latestProducts && latestProducts?.length > 0 ?
          <section className="featured-products latest-products">
  <div className="section-header">
    <h2>LATEST PRODUCTS</h2>
  </div>

 <div className="carousel-wrapper">
              <div className="products-carousel-container-latest">
                <div
                  className="products-carousel-track-latest"
                  style={{
                    transform: `translateX(-${latestCurrentIndex * (100 / cardsPerSlide)}%)`
                  }}
                >
        {latestProducts.map((product) => (
        <div key={product.Id} className="product-card-home" >
                      {(product.Stock === 0 || product.Stock === 0.0) && (
                        <div className="home-product-card-sold-out-badge">Sold Out</div>
                      )}
                      <div className="product-image-home" >
                        <img src={product.Image} alt={product.Name} onClick={() => handleProductView(product)} loading="lazy"/>
                        <div className="product-overlay">
                <button className="overlay-btn" onClick={() => handleAddToCart(product)}><ShoppingCart size={20} style={{
                  transform: "scaleX(-1)",   // FLIP horizontally
                  transformOrigin: "center"
                }} /></button>
                          {/* <button className="overlay-btn"><Search size={20} /></button> */}
                          {/* <button className="overlay-btn"><Shuffle size={20} /></button> */}
                          <button className="overlay-btn" onClick={() => handleAddToWishlist(product)}><Heart size={20} /></button>
                        </div>

                      </div>
                      <div className="product-info-home" onClick={() => handleProductView(product)}>
                        <h3>{product.Name}</h3>
                        <div className="product-pricing">
                          {/* <span className="old-price">AED {(product?.Rate + 20).toFixed(2)}</span> */}
                <span className="current-price" >{(product?.Rate ?? 0).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} AED</span>

                          {/* <button
                            className="enlarge-btn"
                            // style={{marginRight:"30px"}}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent opening popup when clicking enlarge
                              setSelectedProduct(product);
                              setShowPopup(true);
                            }}
                          >
                            <Maximize size={18} />Click to Enlarge
                          </button> */}
                        </div>
                      </div>
                    </div>
        ))}
      </div>
    </div>

    {/* Navigation Buttons - hide when no products or on mobile edge cases */}
  {/* Navigation Buttons */}
              <button className="nav-btn left" style={{ transform: "translateY(20px)" }} onClick={prevLatestSlide}>‹</button>
              <button className="nav-btn right" style={{ transform: "translateY(20px)" }} onClick={nextLatestSlide}>›</button>

    {/* Dots - only show for desktop */}
   
      <div className="dots">
        {Array.from({ length: latestTotalSlides }).map((_, index) => (
          <span
            key={index}
            className={`dot ${index === latestCurrentIndex ? "active" : ""}`}
            onClick={() => setLatestCurrentIndex(index)}
          />
        ))}
      </div>
  
  </div>
</section>
          : ""}

        {/* Brands */}
        {brands && brands.length > 0 ?
          <section className="brands" style={{ width: isMobile ? "100%" : "74%" }}>
            <h2 className="brands-title">Brands</h2>
            <div className="brands-row">
              {brands.map((brand, index) => (
                <div
                  key={brand.Id}
                  className={`brand-card ${selectedBrand?.Id === brand.Id ? 'selected' : ''}`}
                  style={{ backgroundColor: brandColors[index % brandColors.length] }}
                  //onClick={() => {setSelectedBrand(brand)}}
                >
                  <span className="brand-name">{brand.Name}</span>
                </div>
              ))}
            </div>
          </section>
          : null}
      </div>
      <BottomNavigation
        cartCount={cartwishlistCount?.CartCount}
        wishlistCount={cartwishlistCount?.WishlistCount}
        cartItems={cartItems}
        onCartUpdate={()=>setCartTrigger(prev => prev + 1)}
      />

      <Footer />

      {/* Product Details Popup */}
      {showPopup && selectedProduct && (
        <div className="home-product-details-popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="home-product-details-popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="home-product-details-popup-close" onClick={() => setShowPopup(false)}>×</button>
            <div className="home-product-details-popup-layout">
              {/* Left Side - Image */}
              <div className="home-product-details-popup-image-section">
                {selectedProduct.sale && (
                  <div className="home-product-details-popup-discount-badge">-{selectedProduct.sale}%</div>
                )}
                {selectedProduct.Stock === 0 && (
                  <div className="home-product-details-popup-sold-out-badge">SOLD<br />OUT</div>
                )}
                <div className="home-product-details-popup-image-wrapper">
                  <img
                    src={selectedProduct.Image || "/api/placeholder/400/400"}
                    alt={selectedProduct.Name}
                    className="home-product-details-popup-image"
                  />
                </div>
              </div>

              {/* Right Side - Details */}
              <div className="home-product-details-popup-info-section">
                <h1 className="home-product-details-popup-title">{selectedProduct.Name}</h1>

                {/* Price Section */}
                <div className="home-product-details-popup-price-section">
                  {selectedProduct.sale ? (
                    <>
                      {/* <span className="home-product-details-popup-original-price">
                        AED {(selectedProduct.Rate + 20).toFixed(2)}
                      </span> */}
                      <span className="home-product-details-popup-current-price">
                        AED {selectedProduct?.Rate?.toFixed(2)}
                      </span>
                    </>
                  ) : (
                    <span className="home-product-details-popup-current-price">
                      AED {selectedProduct?.Rate?.toFixed(2)}
                    </span>
                  )}
                  {wishlist.some((w) => w.Product === selectedProduct.Id) ? (
                    <button className="home-product-details-popup-added-btn">❤️ Wishlist Added</button>
                  ) : (
                    <button className="home-product-details-popup-wishlist-btn" onClick={() => handleAddToWishlist(selectedProduct)}>❤️ Add to wishlist</button>
                  )}
                  {cartItems.some((c) => c.productId === selectedProduct.Id) ? (
                    <button className="home-product-details-popup-added-btn">✅ In Cart</button>
                  ) : (
                    <button className="home-product-details-popup-add-to-cart" onClick={() => handleAddToCart(selectedProduct)}>🛒 Add to Cart</button>
                  )}
                  {/* <button className="home-product-details-popup-compare-btn">🔄 Compare</button> */}
                </div>

                {/* Product Meta */}
                <div className="home-product-details-popup-meta">
                  <div className="home-product-details-popup-meta-item">
                    <span className="home-product-details-popup-meta-label">SKU:</span>
                    <span className="home-product-details-popup-meta-value">{selectedProduct.Id}</span>
                  </div>
                  <div className="home-product-details-popup-meta-item">
                    <span className="home-product-details-popup-meta-label">Category:</span>
                    <span className="home-product-details-popup-meta-value">{selectedProduct.CategoryName || "N/A"}</span>
                  </div>
                  <div className="home-product-details-popup-meta-item">
                    <span className="home-product-details-popup-meta-label">SubCategory</span>
                    <span className="home-product-details-popup-meta-value">{selectedProduct.SubCategoryName || "General"}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Home;
